import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step7 from './Step7-redux';

export default compose(
  withRouter,
  withNextStep
)(Step7);
